// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2fg6G","title":"Images45_title__Rli2L","images":"Images45_images__3r3Gu"};